module.exports = __webpack_public_path__ + "video/1800-2_YR_2021_Smishing.04f4c444.vtt";